var moduleMap = {
	"./config": () => {
		return Promise.all([__webpack_require__.e(699), __webpack_require__.e(535), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(651), __webpack_require__.e(845), __webpack_require__.e(172)]).then(() => (() => ((__webpack_require__(8172)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(699), __webpack_require__.e(535), __webpack_require__.e(263), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(651), __webpack_require__.e(996), __webpack_require__.e(809)]).then(() => (() => ((__webpack_require__(996)))));
	},
	"./register": () => {
		return Promise.all([__webpack_require__.e(699), __webpack_require__.e(535), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(651), __webpack_require__.e(845), __webpack_require__.e(87)]).then(() => (() => ((__webpack_require__(6087)))));
	},
	"./game-picker": () => {
		return Promise.all([__webpack_require__.e(699), __webpack_require__.e(263), __webpack_require__.e(185), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(358), __webpack_require__.e(400), __webpack_require__.e(502)]).then(() => (() => ((__webpack_require__(6502)))));
	},
	"./app-sidebar": () => {
		return Promise.all([__webpack_require__.e(699), __webpack_require__.e(535), __webpack_require__.e(263), __webpack_require__.e(185), __webpack_require__.e(136), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(651), __webpack_require__.e(358), __webpack_require__.e(996), __webpack_require__.e(400), __webpack_require__.e(995)]).then(() => (() => ((__webpack_require__(900)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});